module.exports = __webpack_public_path__ + "static/img/obj3.42d754d8.png";